<template>
    <v-dialog value="true" persistent fullscreen hide-overlay>
        <v-card flat class="co-dialog-visualizar-modelo" v-if="!carregando">

            <v-toolbar flat dark color="primary" height="50">
                <v-btn icon dark color="text-color-2" @click="voltar">
                    <v-icon> mdi-chevron-left </v-icon>
                </v-btn>
                <v-toolbar-title class="pl-5 toolbar-title">Meus Modelos</v-toolbar-title>
            </v-toolbar>

            <div class="iframe-editor-wrapper">
                <iframe v-if="!!urlIframe" :src="urlIframe" height="100%" width="100%"></iframe>
            </div>
        </v-card>
        <loading-novo v-else :dialog="carregando" />
    </v-dialog>
</template>

<script>
import {actionTypes} from '@/commons/constants'
import LoadingNovo from '@/commons/components/dialogs/LoadingNovo'

export default {
    name: 'VisualizarModelo',
    components: {
        LoadingNovo
    },
    data() {
        return {
            urlIframe: null,
            carregando: true
        }
    },
    async mounted() {
        this.limparSessionEditor()
        await this.buscarUrlModeloEditor()
    },
    methods: {
        async buscarUrlModeloEditor() {
            const modeloId = this.$route.params.id
            const tipo = this.$route.params.tipo

            try {
                const modelo = await this.$store.dispatch(actionTypes.MODELO.URL_VISUALIZAR_MODELO, {
                    id: modeloId,
                    tipo
                })

                this.urlIframe = modelo.url
                this.carregando = false
            } catch {
                this.mostrarNotificacaoErro('Ocorreu um erro ao tentar buscar pelo modelo!')
            }
        },
        limparSessionEditor() {
            sessionStorage.removeItem('jwt')
            sessionStorage.removeItem('redirect')
        },
        voltar() {
            this.$router.push({name: 'modelos'})
        }
    }
}
</script>

<style lang="stylus">
.co-dialog-visualizar-modelo
    .v-toolbar
        border-radius 0px !important

        .toolbar-title
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
            font-size 20px
            line-height 1.5
            color #fff
            font-weight 500

    .iframe-editor-wrapper
        width 100%
        height calc(100vh - 56px)
</style>
